import { connect } from 'react-redux';
import { Dispatch } from 'react';
import { IApplicationState } from '../store';
import { withRouter } from 'react-router';
import Home from '../components/HomePage/Home';
import { MessageRequest } from '../store/messages/types';
import { sendMessage } from '../store/messages/actions';

const mapStateToProps = (state: IApplicationState) => ({
    ...state,
});

const mapDispatchToProps = (dispatch: Dispatch<any>) => ({
    sendMessage: (request: MessageRequest) => dispatch(sendMessage(request))
});

export default
    withRouter(connect(
        mapStateToProps,
        mapDispatchToProps)
        (Home));